<div class="container-fluid">
  <div class="row">
    <div class="alignMenu shadow text-left pt-2 px-1"
      [ngClass]="companyId == 36 ? 'col-md-3 col-lg-2' : 'col-lg-2 col-xl-2'">
      <app-rental-menu
        (companyIdSevenMile)="companyIdSevenMile($event)">
      </app-rental-menu>
    </div>

    <div class="bgMainSection bgBlue text-left"
      [ngClass]="companyId == 36 ? 'col-md-9 col-lg-10' : 'col-lg-10 col-xl-10'">

      <div class="container mainContainer">
        <div class="row">
          <div class="col-5 text-left mt-4">
            <h2 class="mainHeading">Market Rules</h2>
          </div>

          <div class="col-7 text-right mt-4"
            [ngClass]="{'col-lg-5': SwapORamaCustomChanges}">
            <h1 class="mainHeading">{{ marketName }}</h1>
          </div>

          <div class="col-12 col-lg-2 text-left text-lg-right mt-4"
            *ngIf="SwapORamaCustomChanges">
            <a class="text-white language-toggle translator"
              style="text-decoration: none !important;"
              translate="no"
              href="javascript:void(0)"
              onclick="toggleLanguage()">Español</a>
          </div>
        </div>

        <div class="bgWghite shadow mt-2">

          <div *ngFor="let marketRule of filteredMarketRules; let i = index">
            <div class="container">
              <div class="row pt-4 pb-3">

                <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10 text-start">
                  <span class="newsHeading mt-2">
                    {{ marketRule.RuleTitle }}
                  </span>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 text-start">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#modalMarketRuleReadMore"
                    (click)="openMarketRuleModal(marketRule)">
                    Read More
                  </button>
                </div>

              </div>
            </div>
            <hr class="my-0" />
          </div>

          <div class="container"
            *ngIf="filteredMarketRules.length === 0">
            <div class="row py-4">
              <div class="col-12 text-center">
                No active market rules available.
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- Market Rule Read More Modal -->
  <div class="modal fade"
    id="modalMarketRuleReadMore"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalMarketRuleReadMoreTitle"
    aria-hidden="true">

    <div class="modal-dialog modal-dialog-centered modal-lg"
      style="width: 100%;"
      role="document">

      <div class="modal-content">

        <div class="modal-header">
          <span class="modal-title"
            id="modalMarketRuleReadMoreTitle"
            style="font-size: 18px;">
            <b>{{ selectedMarketRule?.RuleTitle }}</b>
          </span>

          <button type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="container">
            <div class="row">

              <!-- Rich Text Rule Description -->
              <div class="col-12 text-left mt-2">
                <div [innerHTML]="marketRuleDescription"></div>
              </div>

              <!-- Rule Images -->
              <div class="col-12 col-lg-8 text-left mt-3"
                *ngIf="selectedMarketRule?.RuleImageURL1 ||
                       selectedMarketRule?.RuleImageURL2">

                <div id="marketRuleImageCarousel"
                  class="carousel slide"
                  data-ride="carousel">

                  <div class="carousel-inner">

                    <div class="carousel-item active"
                      *ngIf="selectedMarketRule?.RuleImageURL1">
                      <img
                        class="img-fluid d-block w-100"
                        [src]="selectedMarketRule.RuleImageURL1"
                        alt="Market rule image 1">
                    </div>

                    <div class="carousel-item"
                      *ngIf="selectedMarketRule?.RuleImageURL2">
                      <img
                        class="img-fluid d-block w-100"
                        [src]="selectedMarketRule.RuleImageURL2"
                        alt="Market rule image 2">
                    </div>

                  </div>

                  <a class="carousel-control-prev"
                    href="#marketRuleImageCarousel"
                    role="button"
                    data-slide="prev">
                    <span class="carousel-control-prev-icon"
                      aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </a>

                  <a class="carousel-control-next"
                    href="#marketRuleImageCarousel"
                    role="button"
                    data-slide="next">
                    <span class="carousel-control-next-icon"
                      aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </a>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Market Rule Read More Modal Ends -->

</div>